export const STATUS_OPTIONS = [
    "Add",
    "Drop",
    "Hold",
    "Stream",
];

export const DURATIONS_OPTIONS = [
    "Long-Term",
    "Short-Term",
    "Spot Start",
    "Stash"
];

export const TEAMS_OPTIONS = [
    "ATL",
    "BKN",
    "BOS",
    "CHA",
    "CHI",
    "CLE",
    "DAL",
    "DEN",
    "DET",
    "GSW",
    "HOU",
    "IND",
    "LAC",
    "LAL",
    "MEM",
    "MIA",
    "MIL",
    "MIN",
    "NOP",
    "NYK",
    "OKC",
    "ORL",
    "PHI",
    "PHX",
    "POR",
    "SAC",
    "SAS",
    "TOR",
    "UTA",
    "WAS",
];

export const POSITIONS_OPTIONS = [
    "PG",
    "SG",
    "SF",
    "PF",
    "C"
];